import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { AnimatedMarqueeProps } from './types';
import { cn, getColorway } from 'utils/styles';
import Button, { ButtonVariant } from 'components/shared/Buttons/BaseButton';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const AnimatedMarquee = ({ sys, color, copy, cta, ctaStyle }: AnimatedMarqueeProps) => {
  const marqueeGroup = Array.from({ length: 10 }).map((_, index) => (
    <div key={index} className="flex items-center gap-4">
      <div {...liveUpdateAttrs(sys?.id, 'copy')} className="font-serif">
        <RichTextCopy copy={copy} />
      </div>
      {cta && (
        <Button
          className="w-[fit-content] py-1 whitespace-nowrap"
          href={cta?.url}
          internalPage={cta?.internalPage}
          variant={ctaStyle?.toLowerCase() as ButtonVariant}>
          {cta?.text}
        </Button>
      )}
    </div>
  ));

  return (
    <section className={cn(getColorway(color))}>
      <div className="overflow-hidden whitespace-nowrap">
        <div
          className="py-4 gap-4 inline-flex animate-[marquee_90s_linear_infinite] hover:animate-pause"
          data-testid="marquee">
          {marqueeGroup}
          {marqueeGroup}
        </div>
      </div>
    </section>
  );
};

export default AnimatedMarquee;
